/**
 * Buddy Hire Card Component
 * Shows available buddy slot for purchase
 */

import { useCurrency } from '@/state';

interface BuddyHireCardProps {
  slotNumber: number;
  cost: number;
  onHire: () => void;
}

export function BuddyHireCard({ slotNumber, cost, onHire }: BuddyHireCardProps) {
  const currency = useCurrency();
  const canAfford = currency >= cost;

  return (
    <div className="p-6 rounded-xl border-2 border-dashed border-gray-600 bg-gray-800/30">
      {/* Empty slot indicator */}
      <div className="flex flex-col items-center text-center mb-6">
        <div className="text-6xl mb-3 opacity-30">🧑‍🤝‍🧑</div>
        <h3 className="font-bold text-lg text-gray-400">
          Buddy Slot {slotNumber}
        </h3>
        <p className="text-sm text-gray-500 mt-1">
          Available for hire
        </p>
      </div>

      {/* Hire button */}
      <button
        onClick={onHire}
        disabled={!canAfford}
        className={`w-full py-3 px-4 rounded-lg font-bold transition-all ${
          canAfford
            ? 'bg-gradient-to-r from-blue-600 to-cyan-600 hover:from-blue-700 hover:to-cyan-700 text-white shadow-lg hover:shadow-blue-500/50'
            : 'bg-gray-700 text-gray-500 cursor-not-allowed'
        }`}
      >
        {canAfford ? (
          <>Hire for {cost}g</>
        ) : (
          <>Need {cost}g</>
        )}
      </button>

      {/* Benefits info */}
      <div className="mt-4 p-3 bg-gray-900/50 rounded-lg">
        <p className="text-xs text-gray-400 text-center">
          Automatically fishes every 6 seconds
        </p>
      </div>
    </div>
  );
}
